/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BulkProductResponseDto } from '../models';
// @ts-ignore
import { CreateProductDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { ProductCascadeDeleteSummaryDto } from '../models';
// @ts-ignore
import { ProductEntity } from '../models';
// @ts-ignore
import { UpdateProductDto } from '../models';
/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows bulk creation and updating of products. Admin and Operator users can manage products for any business group. Self-service users can only manage products for their assigned business groups. Products with matching name and businessGroup are treated as updates.
         * @summary Create or update products in bulk
         * @param {Array<CreateProductDto>} createProductDto Array of products to create or update. Each item must include required fields: name, businessGroup.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkProducts: async (createProductDto: Array<CreateProductDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductDto' is not null or undefined
            assertParamExists('createBulkProducts', 'createProductDto', createProductDto)
            const localVarPath = `/api/v1.0/products/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new product
         * @param {CreateProductDto} createProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (createProductDto: CreateProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductDto' is not null or undefined
            assertParamExists('createProduct', 'createProductDto', createProductDto)
            const localVarPath = `/api/v1.0/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a product by its ID
         * @summary Delete a product
         * @param {string} id ID of the product to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProduct', 'id', id)
            const localVarPath = `/api/v1.0/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get products by single ID or multiple comma-separated IDs
         * @summary Get products by ID
         * @param {string} id Single product ID or multiple comma-separated IDs (e.g., \&quot;id1\&quot; or \&quot;id1,id2,id3\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductById', 'id', id)
            const localVarPath = `/api/v1.0/products/by-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all products for a given business group ID
         * @summary Get products by Business Group ID
         * @param {string} businessGroupId ID of the business group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByBusinessGroupId: async (businessGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessGroupId' is not null or undefined
            assertParamExists('getProductsByBusinessGroupId', 'businessGroupId', businessGroupId)
            const localVarPath = `/api/v1.0/products/by-business-group/{businessGroupId}`
                .replace(`{${"businessGroupId"}}`, encodeURIComponent(String(businessGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search products by ID. Optimized for UI search/autocomplete, returns empty array if nothing found.
         * @summary Search products by ID
         * @param {string} searchId Product ID to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductById: async (searchId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchId' is not null or undefined
            assertParamExists('searchProductById', 'searchId', searchId)
            const localVarPath = `/api/v1.0/products/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search products by Name. Optimized for UI search/autocomplete, returns empty array if nothing found.
         * @summary Search products by Name
         * @param {string} search Product Name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductByName: async (search: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('searchProductByName', 'search', search)
            const localVarPath = `/api/v1.0/products/searchByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a product
         * @param {string} id ID of the product to update
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: string, updateProductDto: UpdateProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id)
            // verify required parameter 'updateProductDto' is not null or undefined
            assertParamExists('updateProduct', 'updateProductDto', updateProductDto)
            const localVarPath = `/api/v1.0/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows bulk creation and updating of products. Admin and Operator users can manage products for any business group. Self-service users can only manage products for their assigned business groups. Products with matching name and businessGroup are treated as updates.
         * @summary Create or update products in bulk
         * @param {Array<CreateProductDto>} createProductDto Array of products to create or update. Each item must include required fields: name, businessGroup.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBulkProducts(createProductDto: Array<CreateProductDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkProductResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBulkProducts(createProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new product
         * @param {CreateProductDto} createProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(createProductDto: CreateProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(createProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a product by its ID
         * @summary Delete a product
         * @param {string} id ID of the product to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCascadeDeleteSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get products by single ID or multiple comma-separated IDs
         * @summary Get products by ID
         * @param {string} id Single product ID or multiple comma-separated IDs (e.g., \&quot;id1\&quot; or \&quot;id1,id2,id3\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all products for a given business group ID
         * @summary Get products by Business Group ID
         * @param {string} businessGroupId ID of the business group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsByBusinessGroupId(businessGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsByBusinessGroupId(businessGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search products by ID. Optimized for UI search/autocomplete, returns empty array if nothing found.
         * @summary Search products by ID
         * @param {string} searchId Product ID to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductById(searchId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductById(searchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search products by Name. Optimized for UI search/autocomplete, returns empty array if nothing found.
         * @summary Search products by Name
         * @param {string} search Product Name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductByName(search: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductByName(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a product
         * @param {string} id ID of the product to update
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: string, updateProductDto: UpdateProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, updateProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * Allows bulk creation and updating of products. Admin and Operator users can manage products for any business group. Self-service users can only manage products for their assigned business groups. Products with matching name and businessGroup are treated as updates.
         * @summary Create or update products in bulk
         * @param {Array<CreateProductDto>} createProductDto Array of products to create or update. Each item must include required fields: name, businessGroup.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkProducts(createProductDto: Array<CreateProductDto>, options?: any): AxiosPromise<BulkProductResponseDto> {
            return localVarFp.createBulkProducts(createProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new product
         * @param {CreateProductDto} createProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(createProductDto: CreateProductDto, options?: any): AxiosPromise<ProductEntity> {
            return localVarFp.createProduct(createProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a product by its ID
         * @summary Delete a product
         * @param {string} id ID of the product to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct(id: string, options?: any): AxiosPromise<ProductCascadeDeleteSummaryDto> {
            return localVarFp.deleteProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get products by single ID or multiple comma-separated IDs
         * @summary Get products by ID
         * @param {string} id Single product ID or multiple comma-separated IDs (e.g., \&quot;id1\&quot; or \&quot;id1,id2,id3\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(id: string, options?: any): AxiosPromise<ProductEntity> {
            return localVarFp.getProductById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options?: any): AxiosPromise<Array<ProductEntity>> {
            return localVarFp.getProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all products for a given business group ID
         * @summary Get products by Business Group ID
         * @param {string} businessGroupId ID of the business group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByBusinessGroupId(businessGroupId: string, options?: any): AxiosPromise<Array<ProductEntity>> {
            return localVarFp.getProductsByBusinessGroupId(businessGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search products by ID. Optimized for UI search/autocomplete, returns empty array if nothing found.
         * @summary Search products by ID
         * @param {string} searchId Product ID to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductById(searchId: string, options?: any): AxiosPromise<Array<ProductEntity>> {
            return localVarFp.searchProductById(searchId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search products by Name. Optimized for UI search/autocomplete, returns empty array if nothing found.
         * @summary Search products by Name
         * @param {string} search Product Name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductByName(search: string, options?: any): AxiosPromise<Array<ProductEntity>> {
            return localVarFp.searchProductByName(search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a product
         * @param {string} id ID of the product to update
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: string, updateProductDto: UpdateProductDto, options?: any): AxiosPromise<ProductEntity> {
            return localVarFp.updateProduct(id, updateProductDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createBulkProducts operation in ProductsApi.
 * @export
 * @interface ProductsApiCreateBulkProductsRequest
 */
export interface ProductsApiCreateBulkProductsRequest {
    /**
     * Array of products to create or update. Each item must include required fields: name, businessGroup.
     * @type {Array<CreateProductDto>}
     * @memberof ProductsApiCreateBulkProducts
     */
    readonly createProductDto: Array<CreateProductDto>
}

/**
 * Request parameters for createProduct operation in ProductsApi.
 * @export
 * @interface ProductsApiCreateProductRequest
 */
export interface ProductsApiCreateProductRequest {
    /**
     * 
     * @type {CreateProductDto}
     * @memberof ProductsApiCreateProduct
     */
    readonly createProductDto: CreateProductDto
}

/**
 * Request parameters for deleteProduct operation in ProductsApi.
 * @export
 * @interface ProductsApiDeleteProductRequest
 */
export interface ProductsApiDeleteProductRequest {
    /**
     * ID of the product to delete
     * @type {string}
     * @memberof ProductsApiDeleteProduct
     */
    readonly id: string
}

/**
 * Request parameters for getProductById operation in ProductsApi.
 * @export
 * @interface ProductsApiGetProductByIdRequest
 */
export interface ProductsApiGetProductByIdRequest {
    /**
     * Single product ID or multiple comma-separated IDs (e.g., \&quot;id1\&quot; or \&quot;id1,id2,id3\&quot;)
     * @type {string}
     * @memberof ProductsApiGetProductById
     */
    readonly id: string
}

/**
 * Request parameters for getProductsByBusinessGroupId operation in ProductsApi.
 * @export
 * @interface ProductsApiGetProductsByBusinessGroupIdRequest
 */
export interface ProductsApiGetProductsByBusinessGroupIdRequest {
    /**
     * ID of the business group
     * @type {string}
     * @memberof ProductsApiGetProductsByBusinessGroupId
     */
    readonly businessGroupId: string
}

/**
 * Request parameters for searchProductById operation in ProductsApi.
 * @export
 * @interface ProductsApiSearchProductByIdRequest
 */
export interface ProductsApiSearchProductByIdRequest {
    /**
     * Product ID to search for
     * @type {string}
     * @memberof ProductsApiSearchProductById
     */
    readonly searchId: string
}

/**
 * Request parameters for searchProductByName operation in ProductsApi.
 * @export
 * @interface ProductsApiSearchProductByNameRequest
 */
export interface ProductsApiSearchProductByNameRequest {
    /**
     * Product Name to search for
     * @type {string}
     * @memberof ProductsApiSearchProductByName
     */
    readonly search: string
}

/**
 * Request parameters for updateProduct operation in ProductsApi.
 * @export
 * @interface ProductsApiUpdateProductRequest
 */
export interface ProductsApiUpdateProductRequest {
    /**
     * ID of the product to update
     * @type {string}
     * @memberof ProductsApiUpdateProduct
     */
    readonly id: string

    /**
     * 
     * @type {UpdateProductDto}
     * @memberof ProductsApiUpdateProduct
     */
    readonly updateProductDto: UpdateProductDto
}

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * Allows bulk creation and updating of products. Admin and Operator users can manage products for any business group. Self-service users can only manage products for their assigned business groups. Products with matching name and businessGroup are treated as updates.
     * @summary Create or update products in bulk
     * @param {ProductsApiCreateBulkProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public createBulkProducts(requestParameters: ProductsApiCreateBulkProductsRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).createBulkProducts(requestParameters.createProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new product
     * @param {ProductsApiCreateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public createProduct(requestParameters: ProductsApiCreateProductRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).createProduct(requestParameters.createProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a product by its ID
     * @summary Delete a product
     * @param {ProductsApiDeleteProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public deleteProduct(requestParameters: ProductsApiDeleteProductRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).deleteProduct(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get products by single ID or multiple comma-separated IDs
     * @summary Get products by ID
     * @param {ProductsApiGetProductByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductById(requestParameters: ProductsApiGetProductByIdRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProducts(options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all products for a given business group ID
     * @summary Get products by Business Group ID
     * @param {ProductsApiGetProductsByBusinessGroupIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductsByBusinessGroupId(requestParameters: ProductsApiGetProductsByBusinessGroupIdRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductsByBusinessGroupId(requestParameters.businessGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search products by ID. Optimized for UI search/autocomplete, returns empty array if nothing found.
     * @summary Search products by ID
     * @param {ProductsApiSearchProductByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public searchProductById(requestParameters: ProductsApiSearchProductByIdRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).searchProductById(requestParameters.searchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search products by Name. Optimized for UI search/autocomplete, returns empty array if nothing found.
     * @summary Search products by Name
     * @param {ProductsApiSearchProductByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public searchProductByName(requestParameters: ProductsApiSearchProductByNameRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).searchProductByName(requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a product
     * @param {ProductsApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateProduct(requestParameters: ProductsApiUpdateProductRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).updateProduct(requestParameters.id, requestParameters.updateProductDto, options).then((request) => request(this.axios, this.basePath));
    }
}
